export default __webpack_public_path__ + "static/media/notification.ae7198af.svg";